export default __webpack_public_path__ + "static/media/headphone.f76c5bac.svg";